/**
 * @file mix-in設定：メディアクエリ
 */

// スタイル設定読み込み
import { breakpoint } from "~/src/styles/constants";

export const mediaQuery = {
    sp: (content) => {
        return `@media (max-width: ${breakpoint.sp}) { ${content} }`;
    },
    spWide: (content) => {
        return `@media (min-width: ${breakpoint.sp}) and (max-width: ${breakpoint.spWide}) { ${content} }`;
    },
    tablet: (content) => {
        return `@media (min-width: ${breakpoint.spWide}) and (max-width: ${breakpoint.tablet}) { ${content} }`;
    },
    pc: (content) => {
        return `@media (min-width: ${breakpoint.tablet}) and (max-width: ${breakpoint.pc}) { ${content} }`;
    },
    pcWide: (content) => {
        return `@media (min-width: ${breakpoint.pc}) { ${content} }`;
    },
};
